import React from 'react';

import * as styles from './PotSticker.styles';

export interface PotStickerProps {
  content: string;
}

export const PotSticker = ({ content }: PotStickerProps) => {
  return (
    <div css={styles.container}>
      <img
        src="https://images.contentstack.io/v3/assets/blt83ec2ae5e0dbde7f/blt6548f70f48c365d0/green_pot.png"
        alt={content}
      />
    </div>
  );
};
